import React, { useMemo, useState } from 'react';
import PatientDetailSegmentNav from './subparts/PatientDetailSegmentNav';
import { PATIENT_DETAIL_TAB_CONFIG } from './subparts/patientDetailTheme';
import PatientQuickActionsMenu from './PatientQuickActionsMenu';
import Overview from './tabs/Overview';
import PatientCommunicationPreferenceCard from './tabs/PatientCommunicationPreferenceCard';

function PatientTabs({ patient, commPrefs, clinicId, onPatientUpdated, onCommPrefsUpdated }) {
    const [activeTab, setActiveTab] = useState('overview');

    const tabs = useMemo(
        () =>
            PATIENT_DETAIL_TAB_CONFIG.map((tab) => {
                const contentById = {
                    overview: <Overview patient={patient} onPatientUpdated={onPatientUpdated} />,
                    'comm-pref': (
                        <PatientCommunicationPreferenceCard
                            patient={patient}
                            onCommPrefsUpdated={onCommPrefsUpdated}
                        />
                    ),
                };

                return {
                    ...tab,
                    content: contentById[tab.id],
                };
            }),
        [patient, onPatientUpdated, onCommPrefsUpdated]
    );

    const activeContent = tabs.find((tab) => tab.id === activeTab)?.content;

    return (
        <div className="patient-detail-tabs">
            <div className="patient-detail-tabs__nav-wrap">
                <PatientDetailSegmentNav
                    tabs={tabs}
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                />

                <PatientQuickActionsMenu
                    patient={patient}
                    commPrefs={commPrefs}
                    clinicId={clinicId}
                    onPatientUpdated={onPatientUpdated}
                />
            </div>

            <div
                className={`patient-detail-tabs__content${
                    activeTab === 'overview' ? ' patient-detail-tabs__content--info-module' : ''
                }`}
            >
                {activeContent}
            </div>
        </div>
    );
}

export default PatientTabs;
